const list = {
  path: 'list',
  component: resolve => require(['../../../../../pages/admin/reviewed/list'], resolve)
}

export default list
